<template>
  <el-button v-if="isParameterShowed" size="small" type="info" disabled>
    Показано
  </el-button>
  <el-button v-else size="small" type="primary" :loading="isLoading" @click="handleClick">
    Показать
  </el-button>
</template>

<script>
export default {
  name: "ShowParameterButton",
  props: {
    parameter: {
      type: [String, Number],
      required: true,
      default: "",
    },
    isParameterShowed: {
      type: Boolean,
      required: true,
      default: false,
    },
    onClick: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    isParameterShowed() {
      if (this.isParameterShowed) {
        this.isLoading = false;
      }
    },
  },
  methods: {
    handleClick() {
      this.isLoading = true;
      this.onClick(this.parameter);
    },
  },
};
</script>
